<div class="cv-upload-page">
  <div class="card">
    <div class="logo">
      <img src="assets/talentmarket.logo.svg" alt="TalentMarket" />
    </div>

    <ng-container [ngSwitch]="state">
      <!-- LOADING -->
      <div *ngSwitchCase="'loading'" class="state-block">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="status-text">Provjera linka...</p>
      </div>

      <!-- INVALID TOKEN -->
      <div *ngSwitchCase="'invalid'" class="state-block">
        <mat-icon class="error-icon">link_off</mat-icon>
        <h2 class="title">Link nije ispravan</h2>
        <p class="message">{{ validation?.errorMessage }}</p>
        <p class="hint">Zatrazite novi link od recruitera.</p>
      </div>

      <!-- VALID — show form -->
      <div *ngSwitchCase="'valid'" class="state-block left-align">
        <h2 class="title">Pozdrav {{ validation?.candidateName }}!</h2>
        <p class="message">Molimo uploadajte svoj zivotopis.</p>

        <div class="file-input-wrapper">
          <label for="cvFile" class="file-label">
            <mat-icon>upload_file</mat-icon>
            <span>{{ selectedFile ? selectedFile.name : 'Odaberi datoteku' }}</span>
          </label>
          <input
            id="cvFile"
            type="file"
            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            (change)="onFileSelected($event)"
          />
        </div>

        <p class="file-meta" *ngIf="selectedFile">
          Velicina: {{ formatSize(selectedFile.size) }}
        </p>

        <p class="client-error" *ngIf="clientErrorMessage">{{ clientErrorMessage }}</p>

        <div class="rules">
          <p>Dozvoljeni formati: <strong>PDF, DOC, DOCX</strong></p>
          <p>Maksimalna velicina: <strong>10 MB</strong></p>
          <p *ngIf="validation?.expiresAt">
            Link vrijedi do: <strong>{{ formatExpiresAt(validation!.expiresAt) }}</strong>
          </p>
        </div>

        <button
          type="button"
          class="primary-btn"
          (click)="onSubmit()"
          [disabled]="!selectedFile"
        >
          Upload zivotopis
        </button>
      </div>

      <!-- UPLOADING -->
      <div *ngSwitchCase="'uploading'" class="state-block">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="status-text">Upload u tijeku...</p>
      </div>

      <!-- SUCCESS -->
      <div *ngSwitchCase="'success'" class="state-block">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h2 class="title">Uspjesno uploadano</h2>
        <p class="message">{{ successMessage }}</p>
        <p class="hint">Mozete zatvoriti ovu stranicu.</p>
      </div>

      <!-- ERROR after submit -->
      <div *ngSwitchCase="'error'" class="state-block">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2 class="title">Upload nije uspio</h2>
        <p class="message">{{ serverErrorMessage }}</p>
        <button type="button" class="primary-btn" (click)="retryUpload()">
          Pokusaj ponovno
        </button>
      </div>
    </ng-container>
  </div>
</div>
